import React from "react";


import { Col } from "react-bootstrap";


export const ApplicationHeaderMotto:React.FC = () => {

    return (
        <Col xs={5} lg={2} xl={2} className={'app-header__service-motto'}>
            <span>What you’re owed,<br/>on autopilot.</span>
        </Col>
    );

};


export default ApplicationHeaderMotto;
